<svg class="icon" [ngStyle]="{ 'width' : width + 'px', 'height': height + 'px'}">
  <use [attr.xlink:href]="svgsetIcon(icon)"></use>
</svg>
